module.exports = __webpack_public_path__ + "static/media/TempCal72.d3b4ac0b.jpg";